<template>
  <el-table
    v-loading="loading"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    :data="arealist"
    max-height="400"
    show-summary
    :summary-method="getSummaries"
    style="width: 100%">
    <el-table-column
      prop="key_code"
      label="エリアID"
      width="140">
      <template #default="scope">{{ scope.row.key_code.substr(5) }}</template>
    </el-table-column>
    <el-table-column
      prop="text"
      label="エリア名">
    </el-table-column>
    <el-table-column
      prop="qty"
      class-name = "right"
      label="部数"
      width="100">
      <template #default="scope">{{ Number(scope.row.qty).toLocaleString() }}</template>
    </el-table-column>
    <el-table-column
      prop="uprice"
      class-name = "right"
      label="単価"
      width="70">
      <template #default="scope">{{ Number(scope.row.uprice).toFixed(1) }}</template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: ['arealist', 'loading'],
  setup() {
    const getSummaries = function(param: any) {
      const { columns, data } = param
      const sums: any = []
      columns.forEach((column: any, index: number) => {
        if (index === 0) {
          sums[index] = '合 計'
          return
        }else if(index === 3) { // 単価は合計しない
          sums[index] = ''
          return
        }
        const values = data.map((item: any) => Number(item[column.property]));
        if(!values.every((value: any) => isNaN(value))) {
          sums[index] = values.reduce((prev: any, curr: any) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if(column.property === "text") {
          sums[index] = data.length + 'エリア'
        }
      })
      return sums
    }

    return {
      getSummaries
    }
  }
})
</script>

<style scoped>
.right {
  text-align: right;
}
.el-table__footer tbody tr {
  color: white;
  background-color: #f5f7fa;
}
</style>
